var $element = document.querySelectorAll('.js-motion');

var scrollAnimation = function() {
  for(var i = 0; i < $element.length; i++) {
    var triggerMargin = 150;

    if (window.innerHeight > $element[i].getBoundingClientRect().top + triggerMargin) {
      $element[i].classList.add('is-motion');
    }
  }
}
window.addEventListener('load', scrollAnimation);
window.addEventListener('scroll', scrollAnimation);